var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-primary",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.4142V17.5C1 18.0523 1.44772 18.5 2 18.5H4.08579C4.351 18.5 4.60536 18.3946 4.79289 18.2071L14.7929 8.20711C15.1834 7.81658 15.1834 7.18342 14.7929 6.79289L12.7071 4.70711C12.3166 4.31658 11.6834 4.31658 11.2929 4.70711L1.29289 14.7071C1.10536 14.8946 1 15.149 1 15.4142Z",
    fill: "#BEBBB3",
    className: "svg-primary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7929 0.707106L13.7071 1.79289C13.3166 2.18342 13.3166 2.81658 13.7071 3.20711L16.2929 5.79289C16.6834 6.18342 17.3166 6.18342 17.7071 5.79289L18.7929 4.70711C19.1834 4.31658 19.1834 3.68342 18.7929 3.29289L16.2071 0.707107C15.8166 0.316583 15.1834 0.316582 14.7929 0.707106Z",
    fill: "#BEBBB3",
    className: "svg-primary"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70711 3.46936L3.46936 1.70711C3.85989 1.31658 4.49305 1.31658 4.88358 1.70711L18.2929 15.1164C18.6834 15.5069 18.6834 16.1401 18.2929 16.5306L16.5306 18.2929C16.1401 18.6834 15.5069 18.6834 15.1164 18.2929L1.70711 4.88358C1.31658 4.49305 1.31658 3.85989 1.70711 3.46936Z",
    strokeWidth: 1.5,
    className: "svg-primary"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5L6.5 5.5",
    stroke: "#BEBBB3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    className: "svg-primary"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5L14 13.5",
    stroke: "#BEBBB3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    className: "svg-primary"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.42b94467.svg";
export { ForwardRef as ReactComponent };